import classNames from "classnames";
import { isEmpty } from "lodash";
import React, { HTMLAttributes, forwardRef } from "react";

import FilterIcon from "ac-components/ac-icons/FilterIcon";

import "./ACTag.less";

export type ACTagProps = {
  label: string;
  secondaryLabelDelimiter?: string;
  onFilterClick?: (tag: string) => void;
  mode?: "label" | "plain";
  selected?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

const ACTag = forwardRef<HTMLSpanElement, ACTagProps>(function ACTag(
  {
    label,
    secondaryLabelDelimiter,
    onFilterClick,
    className,
    children,
    mode,
    selected,
    ...restSpanProps
  },
  ref,
) {
  const delimiter = secondaryLabelDelimiter;
  const primaryLabel =
    delimiter && label.includes(delimiter)
      ? label.split(delimiter)[0] + ":"
      : label;
  const secondaryLabel =
    delimiter && label.includes(delimiter)
      ? label.split(delimiter).slice(1).join(delimiter)
      : "";
  const fullLabel = secondaryLabel
    ? `${primaryLabel}${secondaryLabel}`
    : primaryLabel;

  return (
    <span
      className={classNames(className, "ac-tag text-small-highlight", mode, {
        selected,
      })}
      {...restSpanProps}
      ref={ref}
      title={fullLabel}
    >
      <span className="ac-tag-content">
        {isEmpty(children) ? (
          <>
            {primaryLabel}
            {secondaryLabel ? (
              <span className="ac-tag-secondary-label">{secondaryLabel}</span>
            ) : null}
          </>
        ) : (
          children
        )}
      </span>
      {onFilterClick ? (
        <span
          className="ac-tag-filter-icon"
          onClick={(e) => {
            e.stopPropagation();
            onFilterClick(label);
          }}
        >
          <FilterIcon />
        </span>
      ) : null}
    </span>
  );
});

export default ACTag;
